import type { TFile } from "@/api/shared/file";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";

export enum EPatientFileTypeFilter {
  COMPANY_PICTURE = "company_picture",
  COMPOSITE_VIEW = "composite_view",
  COMPOSITE_VIEW_GENERATED = "composite_view_generated",
  GENERIC_FILE = "generic_file",
  MESSAGE_FILE = "message_file",
  PATIENT_FILE = "patient_file",
  PATIENT_PHOTO = "patient_photo",
  PATIENT_PICTURE = "patient_picture",
  PATIENT_SCAN = "patient_scan",
  PATIENT_SCAN_EXTERNAL = "patient_scan_external",
  PATIENT_SUPPORTING_DOCUMENT = "patient_supporting_document",
  PATIENT_XRAY = "patient_xray",
  PRACTICE_PICTURE = "practice_picture",
  STAFF_PICTURE = "staff_picture",
}

export interface IPatientFilesFilter extends DefaultPaginatedFilters {
  file_type?: EPatientFileTypeFilter;
  file_type__in?: EPatientFileTypeFilter[];
  patient_id?: string;
}

export type TFileWithType = TFile & { file_type?: EPatientFileTypeFilter };
